<template>
  <div v-loading="isLoading" class="launch">
    <!-- <img style="margin-top: -100px;" class="logo" alt="logo" src="../../assets/svgs/logo.svg" /> -->
    <svg class="logo"><use xlink:href="#icon-logo"/></svg>
    <el-form style="width: 300px; margin-top: 40px;">
      <el-form-item label="帳號">
        <el-input type="text" v-model="form.username"></el-input>
      </el-form-item>
      <el-form-item label="密碼">
        <el-input @keyup.enter.native="submit" type="password" v-model="form.password"></el-input>
      </el-form-item>
      <el-button type="primary" @click="submit">登入</el-button>
    </el-form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isLoading: false,
      form: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    goMain () {
      let defaultRouter = this.$store.state.admin.ID === 1 ? 'systemLog-list' : 'message-list'
      if (this.$store.state.admin.AdminLevel == 100) defaultRouter = 'order-list'
      if (this.$store.state.admin.AdminLevel == 10) defaultRouter = 'teamBuying-statistics'
      this.$router.push({ name: defaultRouter })
    },
    submit () {
      if (!this.validateInput()) return
      let payload = JSON.parse(JSON.stringify(this.form))
      this.$services.auth.login(this, payload).then(ok => {
        if (ok) {
          this.$services.fetchMe(this)
            .then(() => {
              if (this.$store.state.admin.AdminLevel > 100) return this.$services.fetchDatas(this)
              return true
            }).then(this.goMain).catch(this.$handleServiceError)
        }
      }).catch(this.$handleServiceError)
    },
    validateInput () {
      var errMsg = null
      if (!this.form.username) {
        errMsg = '請輸入帳號'
      } else if (!this.form.password) {
        errMsg = '請輸入密碼'
      }
      if (errMsg) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
      }
      return errMsg === null
    }
  },
  created () {}
}
</script>

<style scoped>
.launch {
  width: 100%;
  height: 100%;
  background-color: rgb(112, 112, 112);
  position: fixed;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.logo {
  width: 200px;
}
</style>

<style>
.launch .el-form-item__label {
  color: #aaa;
}
</style>
